const uploadEmptyFileErrorModalSupport = {
  label: 'Need to select file'
};

export default uploadEmptyFileErrorModalSupport;
